import { useMutation } from 'react-query';
import axios from 'axios';
import { useContext } from 'react';
import { TerminalAppearanceAPI } from '../../../constants/API';
import { multipartHeaders } from '../../../constants/HeadersAPI';
import { AlertContext } from '../../../context/AlertProvider';
import { AlertType } from '../../../types/enums';
import { defaultSuccessMessage } from '../../../constants/alertText';
import { TerminalButtonMedia } from '../../../types/Admin/TerminalAppearanceTypes';

export const usePostTabloLogo = () => {
  const context = useContext(AlertContext);

  const { mutate: uploadTabloLogo, isLoading: isUploadTabloLogoLoading } = useMutation(
    ['TerminalAppearanceUploadTabloLogo'],
    (file: File) => {
      const formData = new FormData();
      formData.append('file', file);
      return axios.post<TerminalButtonMedia>(
        TerminalAppearanceAPI.uploadTabloLogo,
        formData,
        multipartHeaders()
      );
    },
    {
      onSuccess: () => {
        // Не инвалидируем запросы: загрузка только возвращает URL файла и не сохраняет его в настройках.
        // Инвалидация приводила к refetch и перезаписи form старыми данными с сервера, из-за чего
        // только что выбранный логотип пропадал с превью. После сохранения настроек инвалидация
        // выполняется в usePutTerminalAppearance.
        context?.setAlert({ type: AlertType.Success, message: defaultSuccessMessage });
      }
    }
  );

  return { uploadTabloLogo, isUploadTabloLogoLoading };
};
